import * as React from 'react';
import ReactDropzone, { ImageFile } from 'react-dropzone';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import * as moment from 'moment';
import SectorOfInterest from 'src/entities/SectorOfInterest';
import ResultPageComponent from 'src/modules/commons/result-page/ResultPage.Component';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';
import CountrySelectComponent from 'src/modules/commons/inputs/country-select/CountrySelect.component';
import ImageContainer from 'src/modules/commons/images/Image.container';
import CompanyData from 'src/value-objects/CompanyData';
import Datepicker from 'src/modules/commons/datepicker/Datepicker.component';

export interface ProjectCompanyFormComponentProps {
  formData: CompanyData;
  handleChange: (key: string) => (value: string | File | boolean | SectorOfInterest | moment.Moment) => void;
  handleSubmit: () => void;
  sectorsOfInterest: SectorOfInterest[];
  logo?: File;
  error: boolean;
  errorMessage: {};
  success: boolean;
}

class ProjectCompanyFormComponent extends React.Component<ProjectCompanyFormComponentProps> {

  public render(): React.ReactNode {
    return (
      <div className="tab-content padding-40">
        {!this.props.success ?
          <div>
            <div>
              <p>
                <strong>
                  Los datos que introduzcas deberán ser los mismos que aparecen en tu NIF o NIE:
                </strong>
              </p>
              <p className="question-detail">
                Recuerda, los campos marcados con * son obligatorios
              </p>
              <div className="gap-20"/>
              <div className="row">
                <div className="col-sm-6 col-md-4">
                  <div className="gap-20"/>
                  <div className="md-input">
                    <InputContainer
                      label="Nombre de la compañía"
                      type="text"
                      value={this.props.formData.name || ''}
                      onChange={(value) => this.props.handleChange('name')(value)}
                      required={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-md-4">
                  <div className="gap-20"/>
                  <div className="md-input">
                    <InputContainer
                      label="CIF"
                      type="text"
                      value={this.props.formData.cif || ''}
                      onChange={(value) => this.props.handleChange('cif')(value)}
                      required={true}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 date-group">
                  <Datepicker
                    label="Fecha de constitución"
                    required={true}
                    value={this.props.formData.establishmentDate}
                    handleChange={this.props.handleChange('establishmentDate')}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  {/*// TODO functionality not defined for this checkbox, keep it hidden at the moment*/}
                  <div className="checkbox hide">
                    <input
                      type="checkbox"
                      checked={true}
                      onChange={() => this.props.handleChange('TODO')}
                    />
                    <label className="c-black-text">
                      ¿La dirección comercial de la compañía es diferente a la dirección social de la compañía?
                    </label>
                  </div>
                  <div className="gap-20"/>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-9 col-md-9">
                  <div className="md-input">
                    <InputContainer
                      label="Dirección comercial y social de la compañía"
                      type="text"
                      required={true}
                      value={this.props.formData.address || ''}
                      onChange={(value) => this.props.handleChange('address')(value)}
                    />
                  </div>
                  <div className="gap-20"/>
                </div>
                <div className="col-sm-3 col-md-3">
                  <div className="md-input">
                    <InputContainer
                      label="Ciudad"
                      type="text"
                      required={true}
                      value={this.props.formData.city || ''}
                      onChange={(value) => this.props.handleChange('city')(value)}
                    />
                  </div>
                  <div className="gap-20"/>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-md-4">
                  <div className="md-input">
                    <InputContainer
                      label="Provincia"
                      type="text"
                      required={true}
                      value={this.props.formData.province || ''}
                      onChange={(value) => this.props.handleChange('province')(value)}
                    />
                  </div>
                  <div className="gap-20"/>
                </div>
                <div className="col-sm-6 col-md-4">
                  <div className="md-input">
                    <InputContainer
                      label="Código postal"
                      type="text"
                      required={true}
                      value={this.props.formData.zipCode || ''}
                      onChange={(value) => this.props.handleChange('zipCode')(value)}
                    />
                  </div>
                  <div className="gap-20"/>
                </div>
                <div className="col-sm-6 col-md-4">
                  <CountrySelectComponent
                    value={this.props.formData.country}
                    required={true}
                    onChange={(value) => this.props.handleChange('country')(value)} 
                  />                      
                  <div className="gap-20"/>
                </div>
                <div className="gap-20"/>
              </div>
              <div className="row">
                <div className="col-sm-6 col-md-4">
                  <div className="md-input">
                    <InputContainer
                      label="Email de empresa"
                      type="text"
                      required={true}
                      value={this.props.formData.email || ''}
                      onChange={(value) => this.props.handleChange('email')(value)}
                    />
                  </div>
                  <div className="gap-20"/>
                </div>
                <div className="col-sm-6 col-md-4">
                  <div className="md-input">
                    <InputContainer
                      label="Teléfono de empresa"
                      type="text"
                      required={true}
                      value={this.props.formData.phoneNumber}
                      onChange={(value) => this.props.handleChange('phoneNumber')(value)}
                    />
                  </div>
                  <div className="gap-20"/>
                </div>
                <div className="col-sm-6 col-md-4">
                  <div className="md-input">
                    <InputContainer
                      label="Web"
                      type="text"
                      required={false}
                      value={this.props.formData.website}
                      onChange={(value) => this.props.handleChange('website')(value)}
                    />
                  </div>
                  <div className="gap-20"/>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4 col-md-4">
                  <ReactDropzone
                    className="dropzone text-center pointer"
                    onDrop={(files: ImageFile[]) => {
                      if (files[0]) {
                        this.props.handleChange('logo')(files[0]);
                      }
                    }}
                    multiple={false}
                    accept="image/*"
                  >
                    <div className="logo-dropzone">
                      <ImageContainer 
                        alt={this.props.formData.name}
                        url={this.props.logo || this.props.formData.logo && this.props.formData.logo.url}
                        defaultImagePath="/img/pic-image.png"
                      /> 
                      <p className="text-center">
                        Arrastre el logo * o haz click
                      </p>
                    </div>
                  </ReactDropzone>
                  <div className="gap-10"/>
                  <p className="f-s-12 c-grey">Tamaño recomendado 330 x 130 píxeles</p>
                  <div className="gap-20"/>
                </div>
                <div className="col-sm-8 col-md-8">
                  <div className="control">
                    <InputContainer
                      label=" "
                      type="textarea"
                      placeholder="Descripción de la compañía..."
                      required={false}
                      value={this.props.formData.description}
                      onChange={(value) => this.props.handleChange('description')(value)}
                      maxLength={150}
                    />
                    <div className="gap-10"/>
                    <p className="f-s-12 c-grey">
                      {this.props.formData.description ? this.props.formData.description.length : '0'} / 150 caracteres
                    </p>
                  </div>
                </div>
              </div>
              <div className="gap-20"/>
              <p className="deco-title f-s-16">
                <strong>
                  Datos bancarios de la empresa
                </strong>
              </p>
              <div className="gap-20"/>
              <div className="row">
                <div className="col-sm-6 col-md-6">
                  <div className="md-input">
                    <InputContainer
                      label="IBAN"
                      type="text"
                      required={true}
                      value={this.props.formData.iban}
                      onChange={(value) => this.props.handleChange('iban')(value)}
                    />
                  </div>
                  <div className="gap-20"/>
                </div>
                <div className="col-sm-6 col-md-6">
                  <div className="md-input">
                    <InputContainer
                      label="Código SWIFT / BIC"
                      type="text"
                      required={true}
                      value={this.props.formData.swiftBic}
                      onChange={(value) => this.props.handleChange('swiftBic')(value)}
                    />
                  </div>
                  <div className="gap-20"/>
                </div>
              </div>
              <p className="deco-title f-s-16">
                <strong>
                  Sector/es al que pertenece la empresa
                </strong>
              </p>
              <div className="gap-20"/>
              <div className="row">
                {this.props.sectorsOfInterest.map(
                  (sector, index) => (
                    <div className="col-sm-6 col-md-4" key={index}>
                      <div className="checkbox">
                        <input
                          id={'checkbox' + index}
                          type="checkbox"
                          defaultChecked={
                            this.props.formData.sectorsOfInterest &&
                            this.props.formData.sectorsOfInterest
                              .some((selectedSector: SectorOfInterest) => selectedSector.id === sector.id)
                          }
                          onClick={() => this.props.handleChange('sectorsOfInterest')(sector)}
                        />
                        <label htmlFor={'checkbox' + index}>
                          {sector.name}
                        </label>
                      </div>
                    </div>
                  )
                )}
              </div>
              <div className="gap-20"/>
            </div>

            <div className="gap-20"/>
            <div className="text-right">
              <button
                type="button"
                className="btn btn-primary"
                data-container="body"
                data-html="true"
                data-toggle="popover"
                data-placement="bottom"
                onClick={(e) => this.props.handleSubmit()}
              >
                Guardar
              </button>
              <div className="gap-20"/>
              <ErrorMessagesComponent
                errorMessage={this.props.errorMessage}
              />
            </div>
            {/*TODO*/}
            {/*<p className="text-center">
              <button
                className="btn btn-secondary btn-lg"
                onClick={() => (null)}
              >
                Enviar para revisión
              </button>
            </p>*/}
            <div className="gap-20"/>
          </div> :
          <ResultPageComponent
            title="Los datos de la compañía se han guardado correctamente"
            message=""
            success={true}
          />
        }
      </div>
    );
  }
}

export default ProjectCompanyFormComponent;



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/ProjectCompanyForm.component.tsx